// Vendors
import React, { PropsWithChildren } from 'react';
// Contexts
import { useFeatureFlagsContextHook } from 'contexts/feature-flags.context';
// Types
import { FeatureFlagComponentType } from './types/feature-flag.component.type';
// Utilities
import { isFeatureFlagLoadedAndIsNotVisible } from 'utils/feature-flag.utils';

const FeatureFlagComponent = ({
  children,
  id,
}: FeatureFlagComponentType): React.JSX.Element | PropsWithChildren['children'] => {
  const { featureFlags } = useFeatureFlagsContextHook();

  return isFeatureFlagLoadedAndIsNotVisible({ featureFlags, id }) ? null : children;
};

export { FeatureFlagComponent };
